module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Nest_Cam.a83d2e26.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Nest_Cam.svg
// module id = 3428
// module chunks = 0